import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';

import { NavigationService } from '../services/navigation/navigation.service';
import { StateService } from '../services/state/state.service';

@Injectable({ providedIn: 'root' })
export class AuthGuard {
  constructor(
    private stateService: StateService,
    private navigationService: NavigationService
  ) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    if (this.stateService.getToken()) {
      // authorised -> return true
      return true;
    }

    // not logged in so redirect to login page with the return url
    this.navigationService.navigateToLogin(window.location.href);
    return false;
  }
}
